import gql from 'graphql-tag'

export const DELETE = gql`
  mutation hallOfFamerDelete($id: ID!) {
    hallOfFamerDelete(id: $id) {
      id
    }
  }
`
